import BotbPassModalProvider from "./botb-pass-modal-provider";
import { BotbPassDrawerContent } from "./BotbPassSubscriptionContent";
import { useEffect } from "react";

const BotbCarV2PassModal = ({ place = "" }: { place?: string }) => {
  useEffect(() => {
    document.body.classList.add("overflow-hidden");

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);
  return (
    <BotbPassModalProvider place={place}>
      <BotbPassDrawerContent />
    </BotbPassModalProvider>
  );
};

export default BotbCarV2PassModal;
